<template>
    <overlay-modal class="without-header" ref="overlayModal">
        <template v-slot:header>
            <div>
                <h4 class="cursive mb-0" style="line-height: 40px;">Hotels</h4>
                <div class="d-flex justify-content-between p-2">
                    <div>
                        <span class="text-uppercase" style="line-height: 32px">{{hotels.length}} hotels trovati</span>
                    </div>
                    <div>
                        <button v-if="mode === 1" class="btn btn-secondary btn-sm py-1 px-4" href="javascript:void(0)" @click="mode = 2">
                            <img src="../../../../../assets/images/svg/white/icone_mappa.svg" height="24px"/>
                            <span class="text-uppercase">mappa</span>
                        </button>
                        <button v-if="mode === 2" class="btn btn-secondary btn-sm py-1 px-4" href="javascript:void(0)" @click="mode = 1">
                            <img src="../../../../../assets/images/svg/white/icone_lista.svg" height="24px"/>
                            <span class="text-uppercase">lista</span>
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template>
            <div class="modal-map">
                <div>
                    <div v-if="mode === 1">
                        <div :style="`height: ${windowHeight-55}px;`" class="tasks pb-5">
                            <div v-for="(item, index) in hotelsFiltered" :key="index" @mouseover="onMouseHover(item)">
                                <HotelPanel :minimize="true" :value="item" class="mb-3" :selected="isSelectedHotel(item)" @select="onSelectHotel" @detail="onShowDetail"/>
                            </div>
                        </div>
                    </div>
                    <div v-show="mode === 2" class="p-0">
                        <GmapMap ref="mapRef" :options="{
                               zoomControl: true,
                               mapTypeControl: false,
                               scaleControl: true,
                               streetViewControl: true,
                               rotateControl: true,
                               fullscreenControl: true,
                               disableDefaultUi: false
                             }" :center="center" :zoom="zoom" map-type-id="terrain" class="map mt-4 pb-5" :style="`height: ${windowHeight-70-63}px;`">
                            <gmap-custom-marker :offsetY="-10" :key="index" v-for="(m, index) in markers" :z-index="m.zIndex" @click.native="onSelectMarker(m)" :marker="m" alignment="top">
                                <CustomHotelMarker :value="m" :hover="selectedItem"/>
                            </gmap-custom-marker>
                        </GmapMap>
                    </div>
                </div>
            </div>
            <div>
                <ModalHotelDetail v-if="showItem" :is-selected="isSelectedHotel(showItem)" :value="showItem" ref="modalHotelDetail" @select="onSelectHotel"/>
            </div>
        </template>
        <template v-slot:footer>
            <div class="menu-footer d-flex justify-content-between bg-dark">
                <div class="d-flex justify-content-between px-2 py-1">
                    <div @click="onOpenCloseFilter">
                        <p class="mb-0" style="line-height: 30px"><b>Filtra risultati</b><span> | {{counter}}</span></p>
                    </div>
                    <div>
                        <button class="btn btn-sm btn-secondary mt-1" @click="onResetFilter" :disabled="isDisabledReset">reset</button>
                    </div>
                    <div @mouseleave="openFilter = false">
                        <DropdownFilterHotel v-show="openFilter" :list="list" :value="getFilter" @close="onOpenCloseFilter"/>
                    </div>
                </div>
                <div>
                    <CustomOrderSelect :list="order" class="lg" @change="onChangeOrder"/>
                </div>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { vueWindowSizeMixin } from 'vue-window-size'
import OverlayModal from '../../../../modals/OverlayModal'
import TimeRangeSlider from '../../../common/TimeRangeSlider'
import ServicePanel from '../../../common/ServicePanel'
import CustomOrderSelect from '../../../common/CustomOrderSelect'
import HotelPanel from '../HotelPanel'
import ShowMore from '../../../common/ShowMore'
import {LATITUDE, LONGITUDE} from '../../../../../utils/config'
import {hotelName} from '../../../../../utils/helper'
import DropdownFilterHotel from '../dropdown/DropdownFilterHotel'
import {defaultFiltererHotel, defaultSorterHotel} from '../../../../../utils/hotelUtils'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import CustomHotelMarker from '../../../common/google-map/CustomHotelMarker'
import ModalHotelDetail from './ModalHotelDetail'
import AnalyticEvents from '../../../../common/AnalyticEvents'
import HotelActions from '../../../../actions/HotelAction'

const DEFAULT_BOUND_ZOOM = 13
const DEFAULT_ZOOM = 11

export default {
  name: 'ModalHotelsMobileMap',
  mixins: [vueWindowSizeMixin, AnalyticEvents, HotelActions],
  components: { ModalHotelDetail, CustomHotelMarker, GmapCustomMarker, DropdownFilterHotel, ShowMore, HotelPanel, CustomOrderSelect, ServicePanel, TimeRangeSlider, OverlayModal },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      mode: 1, // 1 list, 2 map
      showItem: this.list[0],
      selectedItem: this.list[0],
      openFilter: false,
      openOrder: false,
      showAll: false,
      center: {lat: LATITUDE, lng: LONGITUDE},
      zoom: DEFAULT_BOUND_ZOOM,
      order: [
        {name: 'prezzo', dir: 'up'},
        {name: 'prezzo', dir: 'down'}
      ]
    }
  },
  computed: {
    counter () {
      return this.hotelsFiltered.length
    },
    getFilter: function () {
      return this.getHotelsFilter()
    },
    isDisabledReset () {
      return Object.values(this.getFilter).every(x => x == null)
    },
    hotels () {
      return this.list
    },
    hotelsFiltered () {
      return this.hotels.filter(this.filtererHotel).sort(this.sortererHotel)
    },
    markers () {
      const list = this.hotelsFiltered
      return list.map((item) => {
        const selected = this.isSelectedHotel(item)
        const delta = this.deltaPrice(item)
        const sign = this.sign(item)
        const abs = this.abs(item)
        const zIndex = selected ? 52 : 50
        const {latitude, longitude, name} = item.hotel.location
        return {name: hotelName(name), lat: latitude, lng: longitude, selected, delta, sign, abs, item, zIndex, hover: false}
      })
    }
  },
  methods: {
    ...mapGetters(['getTypesRating', 'getHotelsFilter', 'getHotelsOrder']),
    ...mapActions(['modifyHotelFilter', 'modifyHotelOrder', 'resetHotelFilter']),
    hotelName,
    open () {
      this.mode = 1
      this.zoom = DEFAULT_BOUND_ZOOM
      const coords = this.markers.map(item => {
        return {lat: item.lat, lng: item.lng}
      })
      this.$refs.mapRef.$mapPromise.then((map) => {
        const bounds = new window.google.maps.LatLngBounds()
        coords.forEach(c => {
          bounds.extend(c)
        })
        map.panToBounds(bounds)
      })
      this.$refs.overlayModal.open()
    },
    close () {
      this.$refs.overlayModal.close()
    },
    onResetFilter: function () {
      this.resetHotelFilter()
    },
    onOpenCloseFilter () {
      this.openFilter = !this.openFilter
    },
    onOpenOrder () {
      this.openOrder = !this.openOrder
    },
    onSelectMarker (marker) {
      this.onShowDetail(marker.item)
    },
    onSelectHotel () {
      this.trackModaleListaHotelSeleziona()
      this.close()
    },
    onShowDetail (hotel) {
      this.showItem = null
      this.$nextTick(() => {
        this.showItem = hotel
        this.$nextTick(() => {
          this.trackModaleListaHotelInfo()
          this.$refs.modalHotelDetail.open()
        })
      })
    },
    isSelectedHotel (hotel) {
      if (!hotel) return false
      const list = this.$store.getters.getSelectedHotelsByPeriod(hotel.period)
      return list.some(item => {
        return hotel.hotel.location.name === item.hotel.location.name
      })
    },
    onMouseHover (item) {
      if (this.selectedItem !== item) {
        this.selectedItem = item
        this.markers.forEach(marker => {
          if (marker.item.hotel.location.name === item.hotel.location.name) {
            marker.hover = true
            marker.zIndex = 3
          } else {
            marker.zIndex = -1
          }
        })
        const latitude = item.hotel.location.latitude
        const longitude = item.hotel.location.longitude
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.zoom = DEFAULT_ZOOM
          map.panTo({lat: latitude, lng: longitude})
        })
      }
    },
    filtererHotel (item) {
      return defaultFiltererHotel(item, this.getHotelsFilter(), this.getTypesRating())
    },
    sortererHotel (a, b) {
      return defaultSorterHotel(a, b, this.getHotelsOrder())
    },
    onChangeOrder: function (order) {
      this.modifyHotelOrder({prezzo: order.dir})
    },
    deltaPrice (item) {
      const selected = this.$store.getters.getSelectedHotelsByPeriod(item.period)[0]
      return item.venditaTotaleEuroBase - selected.venditaTotaleEuroBase
    },
    sign (item) {
      const price = this.deltaPrice(item)
      if (price === 0) return ''
      return price >= 0 ? '+' : '-'
    },
    abs (item) {
      return Math.abs(this.deltaPrice(item))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/modals/ModalHotelsMobileMap.vue